<template>
    <div class="pay_unit">
        <div class="data-wrap">
            <el-form class="leader-style-form" inline :model="searchForm">
                <el-form-item label="用户名称">
                    <el-input
                        v-model="searchForm.pay_unit_name"
                        maxlength="200"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button @click="getPayUnitList">查询</el-button>
                    <el-button @click="addEdit('新增')">新增</el-button>
                </el-form-item>
            </el-form>
            <div class="table-data">
                <el-table class="leader-style-table" border :data="tableData">
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="用户名称"
                        property="pay_unit_name"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="表数量"
                        property="collector_num"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="备注"
                        property="remark"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="修改" align="center" width="200">
                        <template slot-scope="scope">
                            <el-button
                                @click="addEdit('修改', scope.row)"
                                type="text"
                                >修改
                            </el-button>
                            <el-button
                                @click="addEdit('查看', scope.row)"
                                type="text"
                            >
                                查看
                            </el-button>
                            <el-button
                                @click="hanleDelInfo(scope.row)"
                                type="text"
                                >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    class="leader-style-pagination"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增 修改 -->
        <el-dialog
            :title="dialogTitle"
            width="70%"
            :visible.sync="dialogStatus"
            class="leader-dialog"
            :close-on-click-modal="false"
            @close="closeDialog"
        >
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="90px"
                class="leader-style-form"
                :rules="addFormRules"
            >
                <div class="card_title">
                    <span>用户基本信息</span>
                </div>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="用户名称" prop="pay_unit_name">
                            <el-input
                                v-model="addForm.pay_unit_name"
                                maxlength="200"
                                :disabled="dialogTitle == '查看'"
                                placeholder="请输入用户名称"
                            ></el-input> </el-form-item
                    ></el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人" prop="relation_name">
                            <el-input
                                v-model="addForm.relation_name"
                                maxlength="200"
                                placeholder="请输入联系人"
                                :disabled="dialogTitle == '查看'"
                            ></el-input> </el-form-item
                    ></el-col>
                    <el-col :span="8">
                        <el-form-item label="联系方式" prop="relation_phone">
                            <el-input
                                :disabled="dialogTitle == '查看'"
                                v-model="addForm.relation_phone"
                                maxlength="200"
                                placeholder="请输入联系方式"
                            ></el-input> </el-form-item
                    ></el-col>
                </el-row>
                <!-- <el-row>
                    <el-form-item label="备注">
                        <el-input
                            :disabled="dialogTitle == '查看'"
                            v-model="addForm.remark"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入备注"
                        ></el-input>
                    </el-form-item>
                </el-row> -->
                <div class="card_title">
                    <span>表计信息</span>
                    <el-button @click="addInfo" v-if="dialogTitle != '查看'"
                        >新增</el-button
                    >
                </div>
                <div style="text-align: center">
                    <el-radio-group
                        v-model="selectType"
                        class="leader-style-radio power-radio"
                        @change="changeRadio"
                    >
                        <el-radio-button
                            v-for="item in radios"
                            :label="item.point_class_id"
                            :key="item.point_class_id"
                            >{{ item.class_name }}</el-radio-button
                        >
                    </el-radio-group>
                </div>
                <el-table
                    class="leader-style-table custom-table"
                    :data="addForm.power_points"
                    border
                >
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="采集点">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'power_points.' + scope.$index + '.point_id'
                                "
                            >
                                <tree-select
                                    :disabled="dialogTitle == '查看'"
                                    :list="treeListPower"
                                    :obj="treeSelectDefault"
                                    :multiple="false"
                                    :clearable="true"
                                    :checkStrictly="true"
                                    v-model="scope.row.point_id"
                                ></tree-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'power_points.' +
                                        scope.$index +
                                        '.pay_unit_price_id'
                                "
                            >
                                <el-select
                                    v-model="scope.row.pay_unit_price_id"
                                    placeholder="请选择"
                                    :disabled="dialogTitle == '查看'"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :key="item.pay_unit_price_id"
                                        :label="item.pay_unit_price_name"
                                        :value="item.pay_unit_price_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="开始计费日期" align="center">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'power_points.' +
                                        scope.$index +
                                        '.from_date'
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择开始计费日期',
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-date-picker
                                    type="date"
                                    v-model="scope.row.from_date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :disabled="dialogTitle == '查看'"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="截止计费日期" align="center">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'power_points.' + scope.$index + '.to_date'
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择截止计费日期',
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-date-picker
                                    type="date"
                                    v-model="scope.row.to_date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :disabled="dialogTitle == '查看'"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                                @click="deletePowerInfo(scope.row)"
                                class="leader-common-button"
                                v-if="dialogTitle != '查看'"
                                >删除</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" class="leader-common-button">{{
                    dialogTitle == "查看" ? "关闭" : "取消"
                }}</el-button>
                <el-button
                    @click="savePower()"
                    type="primary"
                    v-show="dialogTitle != '查看'"
                    class="leader-common-button"
                    >保存</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import TreeSelect from "@/comon/components/tree-select.vue";
export default {
    components: { TreeSelect },
    data() {
        return {
            searchForm: {
                pay_unit_name: ""
            },
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            dialogTitle: "",
            dialogStatus: false,
            addForm: {
                pay_unit_id: "",
                pay_unit_name: "",
                relation_name: "",
                relation_phone: "",
                pointClassInfoList: [],
                power_points: []
            },
            addFormRules: {
                pay_unit_name: [
                    {
                        required: true,
                        message: "请填写用户名称",
                        trigger: "blur"
                    }
                ],
                relation_name: [
                    {
                        required: true,
                        message: "请填写联系人",
                        trigger: "blur"
                    }
                ],
                relation_phone: [
                    {
                        required: true,
                        message: "请填写联系方式",
                        trigger: "blur"
                    }
                ]
            },
            selectType: "",
            radios: [],
            treeListPower: [],
            treeListWater: [],
            treeSelectDefault: {
                id: "point_id",
                label: "point_name",
                pid: "p_point_id",
                children: "childList"
            },
            options: []
        };
    },
    mounted() {
        this.getPayUnitList();
    },
    methods: {
        // 列表
        getPayUnitList() {
            api.getPayUnitList({
                pay_unit_name: this.searchForm.pay_unit_name,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.totalNum = res.bus_json.totalNum;
                    this.tableData = res.bus_json.items;
                }
            });
        },
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getPayUnitList();
        },
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getPayUnitList();
        },
        // 回显
        getPayUnitInfo(pay_unit_id) {
            api.getPayUnitInfo({ pay_unit_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.addForm = { ...res.bus_json };
                    this.radios = res.bus_json.pointClassInfoList;
                    if (this.radios.length > 0) {
                        this.selectType = this.radios[0].point_class_id;
                        this.addForm.power_points = this.radios[0].payUnitPointInfoList;
                        this.getPointList(this.selectType);
                        this.getPayUnitPriceCodeValue(this.selectType);
                    }
                }
            });
        },
        // 新增 修改
        addEdit(title, row) {
            this.dialogTitle = title;
            this.dialogStatus = true;
            if (title == "新增") {
                this.addForm.pay_unit_id = "";
                this.addForm.pay_unit_name = "";
                this.addForm.relation_name = "";
                this.addForm.relation_phone = "";
                this.addForm.pointClassInfoList = [];
            } else {
                this.addForm.pay_unit_id = row.pay_unit_id;
                this.addForm.pay_unit_name = row.pay_unit_name;
                this.addForm.relation_name = row.relation_name;
                this.addForm.relation_phone = row.relation_phone;
                this.addForm.pointClassInfoList = { ...row.pointClassInfoList };
            }
            this.getPayUnitInfo(this.addForm.pay_unit_id);
        },
        changeRadio(item) {
            this.selectType = item;
            this.getPointList(this.selectType);
            this.getPayUnitPriceCodeValue(this.selectType);
            this.addForm.power_points = [];
            this.addForm.pointClassInfoList.forEach(k => {
                if (k.point_class_id == item) {
                    this.addForm.power_points = k.payUnitPointInfoList;
                    this.$forceUpdate();
                }
            });
        },
        getPointList(point_class_id) {
            api.getCommonPointList({ point_class_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.treeListPower = res.bus_json;
                }
            });
        },
        // 获取电价类型
        getPayUnitPriceCodeValue(point_class_id) {
            api.getPayUnitPriceCodeValue({ point_class_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.options = res.bus_json;
                }
            });
        },
        // 删除
        hanleDelInfo(item) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.deletePayUnit({
                        pay_unit_id: item.pay_unit_id
                    }).then(res => {
                        if (res) {
                            // 最后一页，只有一条数据时，点击删除
                            if (
                                this.totalNum -
                                    (this.pageNum - 1) * this.pageSize ==
                                1
                            ) {
                                // 处理页码显示问题
                                this.pageNum =
                                    this.pageNum == 1
                                        ? this.pageNum
                                        : this.pageNum - 1;
                            }
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getPayUnitList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "未删除"
                    });
                });
        },

        addInfo() {
            this.addForm.pointClassInfoList.forEach(item => {
                if (item.point_class_id == this.selectType) {
                    const row = {
                        point_id: "",
                        pay_unit_price_id: "",
                        from_date: "",
                        to_date: "2099-12-31"
                    };
                    this.addForm.power_points.push(row);
                    item.payUnitPointInfoList = this.addForm.power_points;
                    this.$forceUpdate();
                }
            });
        },

        // 删除信息
        deletePowerInfo(sth) {
            this.addForm.power_points.forEach(function(item, index, arr) {
                if (item == sth) {
                    arr.splice(index, 1);
                }
            });
        },
        savePower() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    api.savePayUnit({
                        ...this.addForm
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.dialogStatus = false;
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.getPayUnitList();
                        }
                    });
                }
            });
        },
        closeDialog() {
            this.dialogStatus = false;
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
            this.$forceUpdate();
        }
    }
};
</script>
<style lang="scss">
.pay_unit {
    width: 100%;
    height: 100%;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;
    .data-wrap {
        // background: url("../../../../assets/image/custom/table-bg.png")
        //     no-repeat;
        background-size: 100% 100%;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        .table-data {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 20px 0;
        }
    }
    .card_title {
        color: #56fcff;
        font-size: 16px;
        border-bottom: 1px solid #56fcff;
        padding-bottom: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
    }
    .power-radio {
        .el-radio-button {
            margin-right: 0.3rem !important;
        }
        .el-radio-button__inner {
            font-size: 0.7rem !important;
            padding: 0.5rem 0.3rem !important;
            border-radius: 5px;
            min-width: 3.5rem;
        }
        .el-radio-button__inner,
        .el-radio-group {
            margin: 0.2rem 0;
        }
    }
    .el-table .cell .el-form-item {
        margin-bottom: 0px !important;
    }
    .custom-table {
        .el-form-item__content {
            margin-left: 0 !important;
        }
    }
}
</style>
